export const Roles = {
  Customer: 'CUSTOMER',
  PlaceholderCustomer: 'PLACEHOLDER_CUSTOMER',
};
export const ClaimTypes = {
  Role: 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
};
